(function ($) {
    'use strict';
    var ajax = $.ajax,
        redirectStatusCode = 278;

    function isRedirectResponse(jqXHR) {
        if (jqXHR && jqXHR.status == redirectStatusCode) {
            return true;
        }

        return false;
    }

    function getRedirectUrl(jqXHR) {
        var url = null;
        url = jqXHR && jqXHR.getResponseHeader('X-RedirectTo');
        if (!url) {
            url = jqXHR && jqXHR.getResponseHeader('Location');
        }
        return url;
    }

    function isJsonResponse(jqXHR) {
        var contentType;
        contentType = jqXHR && jqXHR.getResponseHeader('Content-Type');
        if (!contentType || contentType.indexOf('json') == -1) {
            return false;
        }
        return true;
    }

    function handleResponse(jqXHR, resp) {
        jqXHR.isJsonResponse = isJsonResponse(jqXHR);
        if (isRedirectResponse(jqXHR)) {
            var url = getRedirectUrl(jqXHR);
            if (resp && resp.sessionHasExpired === true && jqXHR.isJsonResponse === true) {
                var messages = TS.cultures.current.sessionExpired;
                TS.UI.Mask.hide();
                TS.MessageBox.show({
                    message: messages.Message,
                    caption: messages.Title,
                    buttons: TS.MessageBox.Buttons.OK,
                    icon: TS.MessageBox.Icons.Information,
                    callback: function () {
                        window.location.href = url;
                    }
                });
                return false;
            }
            window.location.href = url;
            return false;
        }
        return true;
    };

    function done(deferred, settings) {
        return function (resp, status, jqXHR) {
            var self = this,
                callFinally = true;
            try {
                if (handleResponse(jqXHR, resp)) {
                    if (jqXHR.isJsonResponse === true) {
                        if (resp.success === false) {
                            //notifications = TS.Util.getNotifications(resp);
                            //me._showNotifications(notifications, resp.messages);
                        } else {
                            switch (resp.resultType) {
                                case "ShowMessage":
                                    var args = resp.args,
                                        feedback = (args.feedbackUrl !== null && typeof args.feedbackUrl != 'undefined'),
                                        useMask = TS.UI.Mask.isVisible();
                                    if (feedback) {
                                        args.callback = function (button) {
                                            var settings = {
                                                context: self,
                                                type: 'POST',
                                                headers: {'__TS_CONFIRMATION__': true},
                                                url: args.feedbackUrl,
                                                data: '{ result: "' + button + '"}',
                                                contentType: 'application/json; charset=utf-8',
                                                dataType: "json"
                                            };

                                            if (useMask) {
                                                TS.UI.Mask.show();
                                            }
                                            callFinally = false;
                                            $.ajax(settings)
                                                .done(function () {
                                                    deferred.resolve.apply(this, arguments);
                                                })
                                                .fail(function () {
                                                    deferred.reject.apply(this, arguments);
                                                })
                                                .progress(function () {
                                                    deferred.notify.apply(this, arguments);
                                                });
                                        };
                                        TS.UI.Mask.hide();
                                        TS.MessageBox.show(args);
                                        return;
                                    }
                                    TS.MessageBox.show(args);
                                    break;
                                case 'ViewDomain':
                                    setTimeout(function () {
                                        if(resp.closeCurrent === true){
                                            var currentModel = TS.UI.models.peek();
                                            currentModel.isPopup === true && currentModel.close(true, false);
                                        }
                                        (settings.viewDomain || TS.UI.viewDomain)(resp.args);
                                    }, 0);
                                    break;
                            }
                        }
                    }
                    deferred.resolve.apply(this, arguments);
                } else {
                    TS.UI.Mask.hide();
                }
            }
            finally {
                callFinally && settings.finally && settings.finally.apply(this, arguments);
            }
        }
    };


    function failed(deferred, settings) {
        return function (jqXHR, status, error) {
            try {
                if (handleResponse(jqXHR)) {
                    if (jqXHR.isJsonResponse === true) {
                        //show error messages
                    }
                    deferred.reject.apply(this, arguments);
                } else {
                    TS.UI.Mask.hide();
                }
            } finally {
                settings.finally && settings.finally.apply(this, arguments);
            }
        }
    };

    function progress(deferred) {
        return function () {
            deferred.notify.apply(this, arguments);
        }
    };


    $.ajax = function () {
        var settings = arguments.length == 2 ? arguments[1] : arguments[0],
            token = TS.Util.getRequestVerificationToken();
        if (token) {
            settings.headers = settings.headers || {};
            settings.headers.__RequestVerificationToken = token;
        }


        var deferred = $.Deferred(),
            jqXHR = ajax.apply($, arguments),
            result = deferred.promise($.extend({}, jqXHR));

        result.success = result.done;
        result.error = result.fail;

        jqXHR.done(done(deferred, settings))
            .fail(failed(deferred, settings))
            .progress(progress(deferred));

        return result.always(TS.UI.Mask.hide);
    }

})(jQuery);